export default __webpack_public_path__ + "static/media/profileImage8.f1445b00.png";